// socket.js
import { io } from 'socket.io-client';

// Connect to backend (make sure backend is running on port 4000)
// const socket = io('http://localhost:4000', {
//   transports: ['websocket'], // optional: force WebSocket for cleaner local dev
//   withCredentials: true       // optional: if you use cookies/session-based auth
// });
const socket = { off: () => {}, on: () => {}, emit: () => {} };

export default socket;
